import { render, staticRenderFns } from "./manageAssessment.vue?vue&type=template&id=500edf18"
import script from "./manageAssessment.ts?vue&type=script&lang=js&external"
export * from "./manageAssessment.ts?vue&type=script&lang=js&external"
import style0 from "./manageAssessment.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports